import React from 'react';
import { Button } from 'ui';
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useUpgradeInfo } from '../../../hooks/upgrades/queries';
import { useTeamModal } from 'contexts/TeamModalContext';
import ModalComponent from '../modal/ModalComponent';
import AccountPageConstants from 'constants/AccountPageConstants';
import { isMonthly as checkIsMonthly, isAnnual as checkIsAnnual } from '../../../utils/subscriptionUtils';

/**
 * Component for managing billing schedule (monthly vs annual)
 */
const BillingModalSchedule = () => {
  const { navigateToPage } = useTeamModal();
  const { data: subscription } = useSubscription();
  const { data: upgradeInfo, isLoading } = useUpgradeInfo();

  const isMonthly = checkIsMonthly(subscription);
  const isAnnual = checkIsAnnual(subscription);
  
  const savings = upgradeInfo?.upgrade_savings || 0;
  const planId = upgradeInfo?.plan_id || null;
  
  const handleUpgradeClick = () => {
    navigateToPage(AccountPageConstants.ANNUAL_SUBSCRIPTION);
  };
  
  return (
    <ModalComponent>
      <h4>Billing Schedule</h4>
      {isMonthly && <p>You're paying monthly.</p>}
      {isAnnual && <p>You're paying annually.</p>}

      {!isLoading && savings > 0 && isMonthly && (
        <div>
          <p>Save ${savings}/year by paying annually.</p>
          <Button onClick={handleUpgradeClick} variant="white">
            Switch to Annual Billing
          </Button>
        </div>
      )}

      {!isLoading && isAnnual && planId && (
        <div>
          <Button onClick={handleUpgradeClick} variant="white">
            Switch to Monthly Billing
          </Button>
        </div>
      )}
    </ModalComponent>
  );
};

export default BillingModalSchedule;